import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { themeGet, fontSize } from 'styled-system';
import styled from '@emotion/styled';
import { mediaQuery } from 'lib/styledSystem';

const List = styled.ul`
  margin: 0;
  padding: 0;
  margin-top: -${themeGet('space.3')};
  ${mediaQuery.minWidth.sm} {
    display: flex;
    flex-wrap: wrap;
  }
  @media print {
    display: flex;
    flex-wrap: wrap;
  }
`;

const ListItem = styled.li`
  list-style-type: none;
  padding: ${themeGet('space.3')} 0;
  margin: 0;
  border-bottom: 1px solid ${themeGet('colors.greys.alto')};
  ${fontSize};
  ${mediaQuery.minWidth.sm} {
    flex-basis: 50%;
  }
  @media print {
    flex-basis: 50%;
  }
`;

ListItem.displayName = 'ListItem';

const FacilitiesList = memo(({ facilities, fontSize }) => (
  <List>
    {facilities.map((facility) => (
      <ListItem key={facility} fontSize={fontSize}>
        {facility}
      </ListItem>
    ))}
  </List>
));

FacilitiesList.displayName = 'FacilitiesList';

FacilitiesList.propTypes = {
  facilities: PropTypes.arrayOf(PropTypes.string),
  fontSize: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
};

FacilitiesList.defaultProps = {
  facilities: [],
  fontSize: '18px',
};

export default FacilitiesList;
